import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768; // Bootstrap's default mobile breakpoint

function checkIsMobile() {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(checkIsMobile());

  useEffect(() => {
    function handleResize() {
      setIsMobile(checkIsMobile());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}
